import { isDefined } from '../../config/helpers';
import useWindowSize from '../../_hooks/useWindowSize'
import PaperContainer from '@components/Custom/Paper/PaperContainer';

const CategoryLongDescription = ({ isMobile, long_desc, layout }) => {
    const screensize = useWindowSize();
    return (
        <PaperContainer
            className={"p-2 mt-2 reset-list " + ((layout == 'box' && screensize.width > 1200) || (!isDefined(screensize.width) && !isMobile) ? 'f-size_3' : 'f-size_1')}
            html={long_desc}
        />
    )
}

export default CategoryLongDescription